import __request__ from "routing/request";
export function all() {
  return __request__("GET", "/system/indexer/indices", null, {}, {
    "Accept": ["application/json"]
  });
}
export function closed() {
  return __request__("GET", "/system/indexer/indices/closed", null, {}, {
    "Accept": ["application/json"]
  });
}
export function multiple(Requestedindices) {
  return __request__("POST", "/system/indexer/indices/multiple", Requestedindices, {}, {
    "Accept": ["application/json"]
  });
}
export function open() {
  return __request__("GET", "/system/indexer/indices/open", null, {}, {
    "Accept": ["application/json"]
  });
}
export function reopened() {
  return __request__("GET", "/system/indexer/indices/reopened", null, {}, {
    "Accept": ["application/json"]
  });
}
export function indexSetClosed(indexSetId) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/closed`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function indexSetList(indexSetId) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/list`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function indexSetOpen(indexSetId) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/open`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function indexSetReopened(indexSetId) {
  return __request__("GET", `/system/indexer/indices/${indexSetId}/reopened`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function single(index) {
  return __request__("GET", `/system/indexer/indices/${index}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(index) {
  return __request__("DELETE", `/system/indexer/indices/${index}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function close(index) {
  return __request__("POST", `/system/indexer/indices/${index}/close`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function reopen(index) {
  return __request__("POST", `/system/indexer/indices/${index}/reopen`, null, {}, {
    "Accept": ["application/json"]
  });
}
